import { useAppStore } from '@/inertia/AppStore';
import { useMemo } from 'react';

type UiMetaFieldCondition =
  | {
      type: 'show-on-pages';
      data: string[] | undefined;
    }
  | {
      type: 'other';
      data: string[] | undefined;
    };

type UiMetaFieldConditions = Array<UiMetaFieldCondition>;

export const parseConditionsJson = (json: string): UiMetaFieldConditions => {
  const conditions: UiMetaFieldConditions = [];

  try {
    const data = JSON.parse(json ?? '[]') as UiMetaFieldConditions;

    data.forEach((item) => {
      if (item.type === 'show-on-pages') {
        conditions.push(item);
      }
    });
  } catch (e) {
    //
  }
  return conditions;
};

export const getConditionValue = <T extends UiMetaFieldCondition['type']>(
  data: UiMetaFieldConditions,
  type: T
): Extract<UiMetaFieldCondition, { type: T }>['data'] | null | undefined => {
  const condition = data.find((item) => item.type === type) as Extract<UiMetaFieldCondition, { type: T }> | undefined;
  if (!condition) return undefined;

  if (!condition?.data) return null;

  return condition.data ?? undefined;
};

export const useConditionShowOnPage = (conditions: UiMetaFieldConditions) => {
  const currentPage = useAppStore((store) => store.pageType);

  return useMemo(() => {
    const condition = conditions.find((item) => item.type === 'show-on-pages') as UiMetaFieldCondition | undefined;

    if (!condition?.data || !currentPage) return true;

    const pages = [...condition.data];

    if (pages.includes('none')) return false;

    if (pages.includes('home')) {
      pages.push('front_page', 'search', 'view-all');
    }

    return pages.includes(currentPage) || pages.includes('all');
  }, [conditions, currentPage]);
};
